import {SnapshotChipsAllowList} from 'BenchlingConfig';
import getConfig from 'getConfig';
function getAllowList(): SnapshotChipsAllowList {
  return getConfig('ELN_EXPORT_SNAPSHOT_CHIPS_ALLOW_LIST');
}
export function isInAllowList(snapshotChipType: keyof SnapshotChipsAllowList): boolean {
  return getAllowList()[snapshotChipType] ?? false;
}
